import { Component, Inject, OnInit } from '@angular/core';
import { DzModalConfig, DzModalService } from '@blk/daisy/modules/modals';
import { APP_STORE_CONFIG_TOKEN } from '@ddt-web/config';
import { AppStoreConfig } from '@ddt-web/data-service';
import { StoreService } from '@ddt-web/store-service';


@Component({
	templateUrl: './advisory-fee-change-info-dialog.component.html',
	styleUrls: ['./advisory-fee-change-info-dialog.component.scss']
})
export class AdvisoryFeeChangeInfoDialogComponent implements OnInit {
	public showAdvisoryFeeAnnualizedDialog: boolean = false;
	private includeScenarioYield: boolean = false;

	constructor(
		private dzModalConfig: DzModalConfig,
		private dzModalService: DzModalService,
		private storeService: StoreService,
		@Inject(APP_STORE_CONFIG_TOKEN) private storeConfig: AppStoreConfig
	) { }

	public ngOnInit(): void {
		this.includeScenarioYield = this.dzModalConfig.contentData?.includeScenarioYield;
		if (this.includeScenarioYield) {
			this.showAdvisoryFeeAnnualizedDialog = true;
		}
	}

	public onContinue(): void {
		this.dzModalService.close();
	}

	public onCancel(): void {
		this.dzModalService.close();
		this.toggleYield();
	}

	private toggleYield(): void {
		const updateReportConfigObject = { includeScenarioYield: !this.includeScenarioYield };
		this.storeService.upsertOne(this.storeConfig.reportConfig, updateReportConfigObject);
	}
}
